<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <!-- https://www.healthline.com/health/lower-back-stretches#tips -->
  <!-- https://greatist.com/health/back-workouts-at-home#cooldowns -->
  <v-container>
    <v-card class="mx-auto" max-width="550">
    
      <v-app-bar color="#424242" dark dense>
        <v-toolbar-title>Create a new Set</v-toolbar-title>
      </v-app-bar>
      <v-card color="blue lighten-5">
        <div>
          <div>
            <!-- The steps are identified in the currentStep and this is also used to progress through the steps -->
            <v-stepper alt-labels  v-model="currentStep">
              <v-stepper-header>
                <v-stepper-step :complete="displayStepValue> 1"  step="1">Choose Exercises</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="displayStepValue> 2" step="2">Set Name</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">Exercise!</v-stepper-step>
              </v-stepper-header>
            </v-stepper>
        
            <v-stepper alt-labels class="mt-4"></v-stepper>
          </div>

          <!-- STEP 1 -->
          <div  v-if="displayStepValue==1">
            <v-card-text >
              <p class="ma-0 pa-0 text-h6 grey--text text--darken-2 text-center">Exercises are grouped into a Set</p>
              <p class="ma-0 pa-0 text-body-1  grey--text text--darken-2 text-center" >Click an exercise to select</p> 
              <p class="ma-0 pa-0 text-body-1  grey--text text--darken-2 text-center" >Exercises are done in order of selection</p> 
              <p class="ma-0 pa-0 text-body-1  grey--text text--darken-2 text-center">Aim for 4-8 exercises per Set</p>
              <p class="ma-0 pa-0 text-body-1  grey--text text--darken-2 text-center">Theme your Sets into Stretch, Move or Strength exercises</p>
            </v-card-text>             
            <v-card-actions  >
              <v-spacer></v-spacer>                          
               <v-btn  :left="true" :absolute="true"  small outlined color="pink darken-2  white--text" @click="$router.push('/home')"><span>Cancel</span>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn light :right="true" :absolute="true"  color="pink darken-2 white--text" :disabled="this.chosenExercises.length==0" @click="step2()"> <span>Next</span>
              </v-btn>
            </v-card-actions>
            </div>


            <!-- STEP 2 -->
            <div v-else-if="displayStepValue==2" style="min-height: 100px;">
              <v-container>
                <v-card-text >
                    <p class="ma-0 pa-0 grey--text text--darken-2 text-body-1 text-center">Your selected exercises are saved to a Set</p>
                </v-card-text>
                  <v-row>
                    <v-col cols="2"></v-col> 
                    <v-col cols="8">
                    <v-text-field v-model="currentSet.title" label="Set name"></v-text-field>
                    </v-col>
                    <v-col cols="2"></v-col> 
                    </v-row>

                    <v-card-actions  class="mt-8 mb-2">
                      <v-spacer></v-spacer>                          
                       <v-btn  :left="true" :absolute="true"  small outlined color="pink darken-2  white--text" @click="$router.push('/home')"><span>Cancel</span>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn light :right="true" :absolute="true"  color="pink darken-2 white--text" :disabled="saveSetNameEnabled" @click="step3()"> <span>Next</span>
                      </v-btn>
                    </v-card-actions>
                
              </v-container>            
            </div>

            <!-- STEP 3-->

            <div v-else style="min-height: 170px;"> <!-- Step 3-->
              <div v-if="savingSet">
              <v-card-text >
                <v-row class="d-flex justify-center align-center text-h5 text-center ma-1 pa-1 grey--text">
                <v-progress-circular size=20 :width="3" color="blue-lighten-3"  indeterminate></v-progress-circular></v-row>             
                <p class="ma-0 pa-0 text-body-1  grey--text text--darken-2 text-body-1  text-center">Saving the Set</p>
              </v-card-text> 
              </div>
              <div v-else>
               <v-card-text>
                <p class="ma-0 pa-0 text-body-1  grey--text text--darken-2 text-body-1  text-center">When you have chosen your exercises start your Set</p>
                <p class="ma-0 pa-0 text-body-1 grey--text text--darken-2 text-body-1  text-center">Your new Set will be saved to use again</p>
              </v-card-text>    

              <v-card-actions class="d-flex justify-center">
                <v-container fluid>
                  <!-- Row 1 -->
                  <v-row justify="center">
                    <v-col cols="12" sm="6" md="4">
                      <v-btn color="pink darken-2 white--text"  @click="goToSession()">
                        <span>Start Set</span>
                          <v-icon>play_circle</v-icon>
                        </v-btn> 
                  </v-col>
                  </v-row>

                  <!-- Row 2 -->
                  <v-row justify="center">
                   <v-col cols="12" sm="6" md="4">
                      <v-btn color="pink darken-2 white--text"  @click="repeatNewSet()">
                        <span>Create another Set</span>
                      </v-btn> 
                    </v-col>
                  </v-row>

                  <!-- Row 3 -->
                  <v-row justify="center">
                    <v-col cols="12" sm="6" md="4">
                     <v-btn color="pink darken-2 white--text"  @click="$router.push('/home')">
                        <span>Finished</span>
                      </v-btn>  
                   </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>    





            </div>

            </div>

          </div>
        </v-card>

<!-- WARMUP -->
      <v-list two-line>
        <v-list-item-group v-if="displayStepValue==1"

        v-model="selected1" active-class="pink--text" class="exercise-item" color="deep-purple--text"  multiple>

        <template>
          <v-card  color="light-blue lighten-3"  dark >
          <div>
            <div>
            <v-spacer></v-spacer>
              <v-card-text class="ma-0 ml-2 pa-0">
              <p class="ma-0 pa-0 text-body-1 text-center">Warmup</p>
              <p class="ma-0 pa-0 text-center">Gently increase your heart rate. Always good to start with. <br/>
              <strong>Recommended before Strength exercises</strong></p> 
              </v-card-text>
              <v-spacer></v-spacer>
            </div>
          </div>
        </v-card>
        </template>

          <template v-for="(item, index) in warmupExercises">
            
            <v-list-item :key="item.title"  @click="addToSet(item.title)">

              <template>
                <v-list-item-avatar>
                  <v-img :src="item.icon" :max-width="40"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>

                  <v-list-item-title v-text="item.title"></v-list-item-title>
                  <v-list-item-subtitle class="text--primary" v-text="item.target"></v-list-item-subtitle>
                  <!--v-list-item-subtitle>
                  <v-chip :color="item.color" small pill class="white--text" @click="$router.push('/')">{{item.duration}}</v-chip>
                  </v-list-item-subtitle-->
                </v-list-item-content>
        
                <v-list-item-action>
                  <v-chip :color="item.color" small pill class="white--text">{{item.type}}</v-chip>
                  <!--v-checkbox v-model="checkBoxStatus[index]" :input-value="active" color="pink darken-1"></v-checkbox -->
                </v-list-item-action>
              </template>

            </v-list-item>
        
            <v-divider v-if="index < exercises.length - 1" :key="index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>  

<!-- STRETCHES -->
      <v-list two-line>
        <v-list-item-group v-if="displayStepValue==1 "

        v-model="selected2" active-class="pink--text" class="exercise-item" color="deep-purple--text"  multiple>

        <template>
          <v-card  color="light-blue lighten-2"  dark >
          <div>
            <div>
            <v-spacer></v-spacer>
              <v-card-text class="ma-0 ml-2 pa-0">
              <p class="ma-0 pa-0 text-body-1 text-center">Stretch</p>
              <p class="ma-0 pa-0 text-center">Reduce fatigue by increasing blood supply and nutrients to your muscles</p> 
              </v-card-text>
              <v-spacer></v-spacer>
            </div>
          </div>
        </v-card>
        </template>

          <template v-for="(item, index) in stretchExercises">
            <v-list-item :key="item.title"  @click="addToSet(item.title)">

              <template>
                <v-list-item-avatar>
                  <v-img :src="item.icon" :max-width="40"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>

                  <v-list-item-title v-text="item.title"></v-list-item-title>
                  <v-list-item-subtitle class="text--primary" v-text="item.target"></v-list-item-subtitle>
                  <!--v-list-item-subtitle>
                  <v-chip :color="item.color" small pill class="white--text" @click="$router.push('/')">{{item.duration}}</v-chip>
                  </v-list-item-subtitle-->
                </v-list-item-content>
        
                <v-list-item-action>
                  <v-chip :color="item.color" small pill class="white--text">{{item.type}}</v-chip>
                  <!--v-checkbox v-model="checkBoxStatus[index]" :input-value="active" color="pink darken-1"></v-checkbox -->
                </v-list-item-action>
              </template>

            </v-list-item>
        
            <v-divider v-if="index < exercises.length - 1" :key="index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>  

<!-- MOVE -->
      <v-list two-line>
        <v-list-item-group v-if="displayStepValue==1"

        v-model="selected3" active-class="pink--text" class="exercise-item" color="deep-purple--text"  multiple>

        <template>
          <v-card  color="light-blue lighten-1"  dark >
          <div>
            <div>
            <v-spacer></v-spacer>
              <v-card-text class="ma-0 ml-2 pa-0">
              <p class="ma-0 pa-0 text-body-1 text-center">Move</p>
              <p class="ma-0 pa-0 text-center">Increasing your heart rate improves your health</p> 
              </v-card-text>
              <v-spacer></v-spacer>
            </div>
          </div>
        </v-card>
        </template>

          <template v-for="(item, index) in moveExercises">
            <v-list-item :key="item.title"  @click="addToSet(item.title)">

              <template>
                <v-list-item-avatar>
                  <v-img :src="item.icon" :max-width="40"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>

                  <v-list-item-title v-text="item.title"></v-list-item-title>
                  <v-list-item-subtitle class="text--primary" v-text="item.target"></v-list-item-subtitle>
                  <!--v-list-item-subtitle>
                  <v-chip :color="item.color" small pill class="white--text" @click="$router.push('/')">{{item.duration}}</v-chip>
                  </v-list-item-subtitle-->
                </v-list-item-content>
        
                <v-list-item-action>
                  <v-chip :color="item.color" small pill class="white--text">{{item.type}}</v-chip>
                  <!--v-checkbox v-model="checkBoxStatus[index]" :input-value="active" color="pink darken-1"></v-checkbox -->
                </v-list-item-action>
              </template>

            </v-list-item>
        
            <v-divider v-if="index < exercises.length - 1" :key="index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>  

<!-- STRENGTHEN -->
      <v-list two-line>
        <v-list-item-group v-if="displayStepValue==1"

        v-model="selected4" active-class="pink--text" class="exercise-item" color="deep-purple--text"  multiple>

        <template>
          <v-card  color="light-blue"  dark >
          <div>
            <div>
            <v-spacer></v-spacer>
              <v-card-text class="ma-0 ml-2 pa-0">
              <p class="ma-0 pa-0 text-body-1 text-center">Strengthen</p>
              <p class="ma-0 pa-0 text-center">Stronger muscles help prevent injury</p> 
              </v-card-text>
              <v-spacer></v-spacer>
            </div>
          </div>
        </v-card>
        </template>

          <template v-for="(item, index) in strengthExercises">
            <v-list-item :key="item.title"  @click="addToSet(item.title)">

              <template>
                <v-list-item-avatar>
                  <v-img :src="item.icon" :max-width="40"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>

                  <v-list-item-title v-text="item.title"></v-list-item-title>
                  <v-list-item-subtitle class="text--primary" v-text="item.target"></v-list-item-subtitle>
                  <!--v-list-item-subtitle>
                  <v-chip :color="item.color" small pill class="white--text" @click="$router.push('/')">{{item.duration}}</v-chip>
                  </v-list-item-subtitle-->
                </v-list-item-content>
        
                <v-list-item-action>
                  <v-chip :color="item.color" small pill class="white--text">{{item.type}}</v-chip>
                  <!--v-checkbox v-model="checkBoxStatus[index]" :input-value="active" color="pink darken-1"></v-checkbox -->
                </v-list-item-action>
              </template>

            </v-list-item>
        
            <v-divider v-if="index < exercises.length - 1" :key="index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>  

<!-- MINDFUL -->
      <v-list two-line>
        <v-list-item-group v-if="displayStepValue==1"

        v-model="selected5" active-class="pink--text" class="exercise-item" color="deep-purple--text"  multiple>

        <template>
          <v-card  color="light-blue lighten-3"  dark >
          <div>
            <div>
            <v-spacer></v-spacer>
              <v-card-text class="ma-0 ml-2 pa-0">
              <p class="ma-0 pa-0 text-body-1 text-center">Cooldown/Mindful</p>
              <p class="ma-0 pa-0 text-center">Gentle comedown, time to reflect</p> 
              </v-card-text>
              <v-spacer></v-spacer>
            </div>
          </div>
        </v-card>
        </template>

          <template v-for="(item, index) in mindfulExercises">
            <v-list-item :key="item.title"  @click="addToSet(item.title)">

              <template>
                <v-list-item-avatar>
                  <v-img :src="item.icon" :max-width="40"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>

                  <v-list-item-title v-text="item.title"></v-list-item-title>
                  <v-list-item-subtitle class="text--primary" v-text="item.target"></v-list-item-subtitle>
                  <!--v-list-item-subtitle>
                  <v-chip :color="item.color" small pill class="white--text" @click="$router.push('/')">{{item.duration}}</v-chip>
                  </v-list-item-subtitle-->
                </v-list-item-content>
        
                <v-list-item-action>
                  <v-chip :color="item.color" small pill class="white--text">{{item.type}}</v-chip>
                  <!--v-checkbox v-model="checkBoxStatus[index]" :input-value="active" color="pink darken-1"></v-checkbox -->
                </v-list-item-action>
              </template>

            </v-list-item>
        
            <v-divider v-if="index < exercises.length - 1" :key="index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>  


      <v-row v-if="displayStepValue==1">
        <v-col cols="6" class="pl-6  text-left">
        <v-btn small outlined color="pink darken-2  white--text" @click="$router.push('/home')">
          <span>Cancel</span>
        </v-btn> 
        <v-spacer></v-spacer>
        </v-col>
        <v-col cols="6" class="pr-6  text-right">
       <v-btn light color="pink darken-2 white--text" :disabled="this.chosenExercises.length==0" @click="step2()">
                    <span>Next</span>
                  </v-btn>
        <v-spacer></v-spacer>
        </v-col>        
      </v-row>






        <br/>
  



    </v-card>
     <v-snackbar
        v-model="snackbar"
        :timeout=this.snackbarTimeout
        color="orange"
        centered
        rounded="pill"
        top
      >{{snackBarMsg}}

      </v-snackbar>
  </v-container>
</template>

<style>
.v-progress-circular {
margin: 1rem;
}

.exercise-item{
  background-color: #E3F2FD !important;
}
</style>



<script>
import { Auth } from 'aws-amplify'    
import { API } from 'aws-amplify';
import { listExercises } from '@/graphql/queries';
import { createSet } from '@/graphql/mutations';
import { createSetExercises } from '@/graphql/mutations';

export default {

  name: 'ExerciseList',

  data: () => ({
    currentStep: 1,
    savingSet: false,
    selected1: [],
    selected2: [],
    selected3: [],
    selected4: [],
    selected5: [],
    selected6: [],                        
    nameIsSet: false,
    saveSessionEnabled: false,
    snackbarTimeout: 3000,
    searchResults: [],
    checkBoxStatus: [],
    snackbar: false,
    snackBarMsg: "Please select at least 1 execise",
    exercisesDB: [],
    exercises: [],

    chosenExercises: [],
    currentSet: 
    { "id": "",
      "title" : "",
      "type" : "user",
      "setType" : "user", // if created by Microcise can will be one of: Stretch, Move, Strength
      "owner" : "",
      "description": "",
      "session_duration" : "",
      "date" : "",      
      "sequence": 0,
      "exercises": [],
      "sequences": []
    },
    listCreated: false,
  
  }),
  mounted() {

    },
  async created() {
    this.userAuthData = await Auth.currentUserInfo();

    this.getDBExercises();

    },

  computed: {
         warmupExercises: function () {
          let exercises = this.exercises.filter(function (e) {
            return e.type=="Warmup";
          });    

        return(exercises); 
        },
        stretchExercises: function () {
          let exercises = this.exercises.filter(function (e) {
            return e.type=="Stretch";
          });          
        return(exercises); 
        },
        moveExercises: function () {
          let exercises = this.exercises.filter(function (e) {
            return e.type=="Move";
          });          
        return(exercises); 
        },
        strengthExercises: function () {
          let exercises = this.exercises.filter(function (e) {
            return e.type=="Strength";
          });          
        return(exercises); 
        },        
         mindfulExercises: function () {
          let exercises = this.exercises.filter(function (e) {
            return e.type=="Mindful";
          });     
        return(exercises); 
        },                         
        saveSetNameEnabled: function () {
          return(this.currentSet.title.length==0); 

        },
        displayStepValue: function () {
          console.log("currentStep")
          console.log(this.currentStep)
          return this.currentStep
        }
    },

  methods: {
    step2() {
      this.currentStep=2
    },
    step3() {
      this.currentStep=3
      this.savingSet=true
      this.saveSet()

    },
    goToSession() {
      this.$router.push({ path: 'session', query: { setID: this.currentSet.id } })
    },
    repeatNewSet() {
      this.selected1=[]
      this.selected2=[]
      this.selected3=[]
      this.selected4=[]
      this.selected5=[]
      this.selected6=[]
      this.currentSet=
    { "id": "",
      "title" : "",
      "type" : "user",
      "setType" : "user", // if created by Microcise can will be one of: Stretch, Move, Strength
      "owner" : "",
      "description": "",
      "session_duration" : "",
      "date" : "",      
      "sequence": 0,
      "exercises": [],
      "sequences": []
    }
      this.chosenExercises=[] // cleardown
      this.currentStep=1
      this.$router.push({ path: 'newset'})
    },
    async getDBExercises () {


      await API.graphql({
          query: listExercises,
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        }).then((response) => {
        

      this.exercises = response.data.listExercises.items;

      //const stretchExercises = this.exercises.filter(exercise.type => exercise.type=="Stretch");
     
     //let bigCities = this.exercises.filter(function (e) {
     //   return e.type=="Stretch";
     // });


      this.exercises.sort(function(a, b) {
        return parseInt(a.displayOrder - b.displayOrder);
      });

      //    this.exercises.sort((a, b) => {
      //    return (parseInt(a.displayOrder) === parseInt(b.displayOrder))? 0 : a.displayOrder? -1 : 1;
      //    //return (a.displayOrder === b.displayOrder)? 0 : a.displayOrder? 1 : -1;
      //  });

          for(let i=0;i<this.exercises.length;i++) {
            this.checkBoxStatus.push(false);
          }
      }).catch(e => {
        console.log('getDBExercises.Errors: ' + e.message);
      }); 
    },

    addToSet(title) {

      const index = this.exercises.findIndex(exercise => exercise.title === title);
  
      // At this stage, just keep a list of ids
      var foundIndex = this.chosenExercises.indexOf(index);
      if (foundIndex !== -1) {
        this.chosenExercises.splice(foundIndex, 1);
      } else {
        this.chosenExercises.push(index)
      }

    },

//    setSetName() {
//
//      if(this.currentSet.title.length==0) {
//        this.snackBarMsg="Please enter a name for your new set"
//        this.snackbar=true;
//      } else {
//          this.nameIsSet=true
//      }
//    },

   async saveSet() {

     if(this.chosenExercises.length==0) {
        this.snackBarMsg="Please select at least 1 execise"
        this.snackbar=true;
        return;
      }


      for (var indexID = 0; indexID < this.chosenExercises.length; indexID++) {

          let sequence={
            'sequence': 0,
            'exercise': 0
          };
        
          sequence.sequence = this.currentSet.sequence++
          sequence.exercise = this.exercises[this.chosenExercises[indexID]].id

          try {
            this.currentSet.exercises.push(this.exercises[this.chosenExercises[indexID]]);
            this.currentSet.sequences.push(sequence);
          }  catch (ex) {
            console.log('saveSet. Error', ex.message);
          }

      }


      var exercises = this.exercises;
  
      var session_duration = exercises.map(exercise => exercise.duration).reduce((acc, exercise) => exercise + acc);
      var minutes = Math.floor(session_duration / 60);
      var seconds = session_duration - minutes * 60; 
     
      this.currentSet.session_duration = minutes + ":" + seconds;
      this.currentSet.owner=this.userAuthData.username

//
// ERROR HANDLING NEEDED HERE.........
//
      // 
      // Create the Set. This creates a new set (with ID) and fills the mapping table to link the exercises
      //
      let setData;

      try {

          setData= {
            "description" : "", 
            "title" : this.currentSet.title, 
            "type": this.currentSet.type, 
            "owner" : this.currentSet.owner,
            "sequences" : JSON.stringify(this.currentSet.sequences)}


        }  catch (ex) {
                console.log('createSet. creating json Error', JSON.stringify(ex.message));
        }


        let newSet={}
        try {
            newSet = await API.graphql({ 
            query: createSet, 
            variables: { input: setData },
            authMode: 'AMAZON_COGNITO_USER_POOLS'}

            ).then((response) => {
  
              newSet = response.data;
              this.currentSet.id=newSet.createSet.id

              try {
                // Add the links to the exercises
                for(let i=0;i<this.currentSet.exercises.length;i++) {
                    this.createSetExercises(this.currentSet.id, this.currentSet.exercises[i].id)     
                  }
              } catch (err) {
                console.log("Error occurred while creating the linked exercises ", err);
              }

            });
  
        }  catch (ex) {
          console.log('saveSet. Error', ex.message);
        }


        //this.snackBarMsg="Saving your new set...."
        //this.snackbarTimeout=4000
        //this.snackbar=true;

        // calls delay() which is defined just below
        //this.delay(4000).then(() => this.$router.push({ path: 'session', query: { setID: this.currentSet.id } }));

        // change UI message
        this.delay(4000).then(() => this.savingSet=false);

      },

    delay(time) {
        return new Promise(resolve => setTimeout(resolve, time));
    },

    
  async createSetExercises(setID, exerciseID) {

      let setExeriseData =  
      '{ "setID": "' + setID  +           
      '" , "exerciseID": "' + exerciseID +           
      '"}';

      const setExeriseDataObj = JSON.parse(setExeriseData);    

      try {
        await API.graphql({ 
          query: createSetExercises, 
          variables: { input: setExeriseDataObj },
          authMode: 'AMAZON_COGNITO_USER_POOLS'});

      } catch (err) {
        console.log("Error occurred while creating SetExercise entry", err);
      }
  }, 



  }          
}
</script>

<style>
.long-button {
  margin-left: auto;
  margin-right: auto;
}
</style>
